import React from 'react';

export type Props = {
  className?: string;
  height?: number;
  onClick?(): void;
  width?: number;
};
export const YoutubeCircle = React.memo((props: Props) => {
  return (
    <svg
      width={props.width || 40}
      height={props.height || 40}
      className={props.className}
      onClick={props.onClick}
      viewBox='0 0 40 40'
    >
      <g fill='none'>
        <rect width='40' height='40' rx='20' fill='white'/>
        <path d='M31.498 14.186C31.3624 13.6753 31.095 13.2092 30.7226 12.8343C30.3502 12.4594 29.8858 12.189 29.376 12.05C27.505 11.545 20 11.545 20 11.545C20 11.545 12.495 11.545 10.623 12.05C10.1134 12.1892 9.64929 12.4598 9.27708 12.8346C8.90486 13.2095 8.63759 13.6755 8.502 14.186C8 16.07 8 20 8 20C8 20 8 23.93 8.502 25.814C8.63759 26.3248 8.90498 26.7909 9.27739 27.1658C9.64981 27.5407 10.1142 27.8111 10.624 27.95C12.495 28.455 20 28.455 20 28.455C20 28.455 27.505 28.455 29.377 27.95C29.8869 27.8112 30.3513 27.5408 30.7237 27.1659C31.0961 26.791 31.3635 26.3248 31.499 25.814C32 23.93 32 20 32 20C32 20 32 16.07 31.498 14.186ZM17.545 23.568V16.432L23.818 20L17.545 23.568Z' fill='var(--footer-social-icons-color)'/>
      </g>
    </svg>
  );
});

YoutubeCircle.displayName = 'YoutubeCircle';
